import ts from 'typescript';
import { EvaluateExpressionError } from '../errors';
import type { Evaluator } from '../types';

const evaluateCallExpression: Evaluator<ts.CallExpression> = ({
  node,
  variables,
  log,
  evaluators,
}) => {
  if (ts.isPropertyAccessExpression(node.expression)) {
    const expressionValue = evaluators.expression({
      evaluators,
      log,
      node: node.expression.expression,
      variables,
    });

    if (node.expression.name.escapedText === 'includes') {
      const argument = evaluators.expression({
        evaluators,
        log,
        node: node.arguments[0],
        variables,
      });

      if (argument === null || argument === undefined) {
        return false;
      }

      if (Array.isArray(expressionValue) || typeof expressionValue === 'string') {
        // don't strictly check the type of the accessor, just let javascript try.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return expressionValue.includes(argument as any);
      }
      return false;
    }
  }

  log.error(new EvaluateExpressionError('Unsupported CallExpression', { kind: node.kind }), 'evaluate-expression-error');
  log.info({ node, variables }, 'evaluate-expression-error');

  return undefined;
};

export default evaluateCallExpression;
